import Aos from "aos";
import "aos/dist/aos.css";
import React, { useEffect } from "react";
import Analysis from "../../img/FinalEdit/AnalysisCertification.png";
import MEC from "../../img/Mec Logo.png";
const Education = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <div className="container px-10 mx-auto my-20">
      <div
        data-aos="fade-up"
        className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-x-8 gap-y-12"
      >
        <div data-aos="flip-right">
          <img className="object-contain h-full w-full" src={Analysis} alt="" />
        </div>
        <div>
          <h1
            data-aos="flip-left"
            className="mt-6 pt-6 text-center mb-2 font-bold text-4xl md:text-5xl lg:text-6xl"
          >
            Education
          </h1>
          <h3 className="pt-6 text-center mb-2 font-bold text-2xl md:text-2xl lg:text-2xl">
            Basic Qualification and Certifcations
          </h3>

          <div className="my-12">
            {/* <p className=" text-gray-500 sm:text-base md:text-2xl lg:text-2xl">
              ⚡ Designing user interface web applications & Customizing logo
              designs and illustration
            </p> */}
          </div>
        </div>
      </div>

      {/* SECOND SECTION */}

      <div className="mt-20 pt-12">
        <div
          data-aos="fade-up"
          class="grid sm:grid-cols-1 md:grid-cols-3  gap-y-12 "
        >
          <div data-aos="flip-right" class="col-span-1 ...">
            <div class="flex flex-wrap justify-center">
              <div class="shadow-2xl rounded-full">
                <img
                  src={MEC}
                  alt="..."
                  class="shadow rounded-full max-w-full h-auto align-middle border-none"
                />
              </div>
            </div>
          </div>
          <div data-aos="flip-left" class="col-span-2 ...">
            <div class="rounded overflow-hidden shadow-lg">
              <div class="font-bold text-xl mb-2 bg-purple-200">
                <h1 className="mb-2 font-bold text-2xl md:text-3xl lg:text-4xl">
                  Mymensingh Engineering College
                </h1>
                <div className="flex justify-between ">
                  <h1>BSc in Computer Engineering</h1>
                  <p className="px-4">2019-Present</p>
                </div>
              </div>
              <div class="px-6 py-4">
                <h1 class="text-gray-700">
                  🌠 In my academic education, I have studied in basic C, C++and
                  JAVA language
                </h1>
                <h1 class="text-gray-700">
                  🌠 I have studied basic software engineering subjects like DS,
                  Algorithms, OOP etc.
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Certification */}

      {/* <div data-aos="fade-down" className="mt-20 pt-12">
        <h1 className="text-center mb-2 font-bold text-4xl md:text-5xl lg:text-6xl">
          Certifications
        </h1>
        <div className="mt-8 grid lg:grid-cols-3 gap-10">
          <div data-aos="fade-up" className="mx-auto">
            <div class="max-w-sm rounded overflow-hidden shadow-lg">
              <img
                class="w-full h-48"
                src={certificationOne}
                alt="Certificate"
              />
              <div class="px-6 py-4">
                <div class="font-bold text-xl mb-2">BDAPPS(ROBI)</div>
                <p class="text-gray-700 text-base">
                  For the participation in BDAPPS App Marketing
                  Masterclass,virtually held in 27th November,2020
                </p>
              </div>
              <div class="px-6 pt-4 pb-2"></div>
            </div>
          </div>
          <div data-aos="fade-up" className="mx-auto"></div>
          <div data-aos="fade-up" className="mx-auto"></div>
        </div>
      </div> */}
    </div>
  );
};

export default Education;
